import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Textarea as ChakraTextarea,
  TextareaProps as ChakraTextareaProps,
} from '@chakra-ui/react';
import { ForwardRefRenderFunction, forwardRef } from 'react';
import { FieldError } from 'react-hook-form';

interface TextareaProps extends ChakraTextareaProps {
  name: string;
  label?: string;
  error?: FieldError;
}

const TextareaBase: ForwardRefRenderFunction<
  HTMLTextAreaElement,
  TextareaProps
> = ({ name, label, error, ...props }, ref) => {
  return (
    <FormControl isInvalid={Boolean(error)}>
      {label && (
        <FormLabel
          htmlFor={name}
          fontFamily="mono"
          fontSize="11px"
          letterSpacing="0.12em"
          textTransform="uppercase"
          color="text.faint"
          mb="8px"
        >
          {label}
        </FormLabel>
      )}

      <ChakraTextarea
        ref={ref}
        id={name}
        name={name}
        variant="unstyled"
        borderRadius="0"
        borderBottom="1px solid"
        borderColor="line.strong"
        bg="transparent"
        color="text.primary"
        rows={4}
        px="0"
        py="12px"
        fontSize="16px"
        resize="vertical"
        _placeholder={{ color: 'text.faint' }}
        _hover={{ borderColor: 'text.muted' }}
        _focus={{ borderColor: 'accent.500', boxShadow: 'none' }}
        {...props}
      />

      {error && (
        <FormErrorMessage fontSize="13px" color="accent.500">
          {error.message}
        </FormErrorMessage>
      )}
    </FormControl>
  );
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  TextareaBase,
);
